import { AppEnvironment } from './environment.model';
import { EnvEnum } from "./env-enum";

export const environment: AppEnvironment = {
  production: false,
  appVersion: '1.0.0',
  env : EnvEnum.hml,
  apiIdentityUrl: 'https://arete-identity-service-hml.aretelearningsystems.com.br/api/v1',
  apiManagementUrl: 'https://arete-management-core-service-hml.aretelearningsystems.com.br/api/v1',
  apiAssessmentUrl: 'https://arete-assessment-core-service-hml.aretelearningsystems.com.br/api/v1',
  apiReportUrl: 'https://arete-report-service-hml.aretelearningsystems.com.br/api/v1',    
  browserCookieSessionEnabled: false,

  LIVEKIT_SERVER_URL : 'wss://arete-yeue9tsn.livekit.cloud',
  LIVEKIT_ARETE_API : 'https://livekit-api-hml.aretelearningsystems.com.br/api',

  LIVEKIT_ARETE_ORAL_TEST_TEMPLATE : 'https://livekit-oral-test-template.aretelearningsystems.com.br',
  
  LOCAL_STORAGE_KEY : "localUserGpOsce",

  // Item Management backend SERVICE ROOT (no /api/v1 — its controllers declare
  // their own prefix, and some carry api/v1 while others do not).
  apiItemManagementUrl: 'https://api-item-manager-hml.aretelearningsystems.com.br',

  itemManagerRemoteEntry: 'https://item-manager-hml.aretelearningsystems.com.br/remoteEntry.json',
  itemManagementLegacyRoutes: false,

  // Keep the DEV cutover set intact. The remote route additionally requires
  // ITEM_MANAGER entitlement and a protected account probe before activation.
  featureFlags: {
    itemManagement: true,
    simulatedStationOrders: true,
    myActivities: false,
    adminExperience: false,
    itemManagementSlices: {
      items: true,
      authoring: true,
      review: true,
    },
  },
  // Production flow follow-up e-mail reminders: prepared, not implemented (#704 §C).
  features: {
    productionFlowEmailReminders: false,
    acompanhamentoUnificado: true,
  },

  // Feature flag: render the left sidebar menu. Disabled by default.
  sidebarEnabled: false,
  // Browser tracing -> otel-collector -> Grafana Tempo.
  tracing: {
    enabled: true,
    collectorUrl: 'https://otel-hml.aretelearningsystems.com.br/v1/traces',
    sampleRatio: 0.1,
    serviceName: 'arete-frontend',
  },
  SENTRY_ENV : "hml",
  SENTRY_RATE : 0.5,
  turnstile: {
    enabled: false,
    siteKey: '1x00000000000000000000AA'
  },
  cookieConsent: {
    enabled: true
  },
  terms: {
    legacyHtmlFallback: true
  }

};
